import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as customerActions from "../../../actions/customerActions";
import * as userActions from "../../../actions/userActions";
import * as projectActions from "../../../actions/projectActions";
import * as departmentActions from "../../../actions/departmentActions";
import * as codeActions from "../../../actions/codeActions";
import * as callActions from "../../../actions/callActions";
import * as serviceActions from "../../../actions/serviceActions";

import HeaderWrapper from "../../common/HeaderWrapper";

import SourceSide from "./SourceSide";
import DestinationSide from "./DestinationSide";

const BulkCallMigrationPage = ({ actions, auth }) => {
  const [sourceCalls, setSourceCalls] = useState([]);
  const [destinationCalls, setDestinationCalls] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [needRefetch, setNeedRefetch] = useState(false);
  const [needResetFiltersDestination, setNeedResetFiltersDestination] =
    useState(false);
  const [isMigrating, setIsMigrating] = useState(false);
  const [customerId, setCustomerId] = useState("");

  useEffect(() => {
    actions.loadProjects();
    actions.loadCustomers();
    actions.loadDepartments();
    actions.loadUsers();
    actions.loadAllUsers();
    actions.loadCodes();
    actions.loadServices();
  }, [actions]);

  const handleMoveToDestination = (call) => {
    if (
      !allSelected &&
      destinationCalls.findIndex((c) => c._id === call._id) < 0
    ) {
      setDestinationCalls((prev) => [...prev, call]);
    }
  };

  const handleRemoveFromDestination = (call) => {
    const calls = destinationCalls.filter((c) => c._id !== call._id);
    const copy = [...sourceCalls];
    const index = copy.findIndex((c) => c._id === call._id);
    copy[index] = { ...copy[index], highlight: false };
    setSourceCalls(copy);
    setDestinationCalls(calls);
  };

  const handleSelectAll = (selected) => {
    if (selected) {
      const calls = sourceCalls.map((call) => ({ ...call, highlight: true }));
      setDestinationCalls(
        sourceCalls.map((call) => ({ ...call, highlight: false }))
      );
      setSourceCalls(calls);
    } else {
      const calls = sourceCalls.map((call) => ({ ...call, highlight: false }));
      setDestinationCalls([]);
      setSourceCalls(calls);
    }
    setAllSelected(selected);
  };

  const handleStartMigration = async (filters) => {
    setIsMigrating(true);
    const callsToMigrate = destinationCalls.map((call) => ({ _id: call._id }));
    const filtersToSend = {
      customer: filters.customer.value,
      project: filters.project.value,
      call_type: filters.call_type.value
    };
    const migrationResult = await actions.migrateMultipleCalls(
      callsToMigrate,
      auth.user,
      filtersToSend
    );
    if (migrationResult) {
      setNeedRefetch(true);
      setDestinationCalls([]);
      setNeedResetFiltersDestination(true);
      handleSelectAll(false);
      setCustomerId("");
    }
    setIsMigrating(false);
  };

  const handleSetSourceCalls = (calls) => {
    setSourceCalls(calls);
    if (!calls.length) {
      setDestinationCalls([]);
    }
  };

  return (
    <div id="bulk-migration-wrapper">
      <HeaderWrapper breadcrumbs={[{ label: "Bulk Call Migration" }]} />
      <div className="sides-container side-x-side">
        <SourceSide
          calls={sourceCalls}
          needRefetch={needRefetch}
          setNeedRefetch={setNeedRefetch}
          onSetSourceCalls={handleSetSourceCalls}
          onCallClick={handleMoveToDestination}
          onSelectAll={handleSelectAll}
          setAllSelected={setAllSelected}
          setCustomerId={setCustomerId}
          allSelected={allSelected}
        />
        <DestinationSide
          customerId={customerId}
          calls={destinationCalls}
          needResetFiltersDestination={needResetFiltersDestination}
          saving={isMigrating}
          setNeedResetFiltersDestination={setNeedResetFiltersDestination}
          onCallClick={handleRemoveFromDestination}
          onStartMigration={handleStartMigration}
          onSetDestinationCalls={setDestinationCalls}
        />
      </div>
    </div>
  );
};

BulkCallMigrationPage.propTypes = {
  actions: PropTypes.object,
  auth: PropTypes.object
};

const mapStatesToProps = (state) => ({
  state: state.reducers,
  auth: state.reducers.auth
});

BulkCallMigrationPage.defaultProps = {
  actions: {}
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userActions,
        ...departmentActions,
        ...projectActions,
        ...customerActions,
        ...codeActions,
        ...callActions,
        ...serviceActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(BulkCallMigrationPage);
